export const init = () => {
    const observer = new MutationObserver(() => {
        const elements = document.querySelectorAll('[data-js-api]:not([data-js-api-applied])');
        elements.forEach(item => {
            const parsedJson = JSON.parse(item.getAttribute('data-js-api'));
            item.setAttribute('data-js-api-applied', 'true');

            const handleEvent = async (e) => {
                e.preventDefault();
                const formData = createFormData(parsedJson.data);
                try {
                    const data = await sendData(parsedJson.url, formData);
                    data.data.forEach(processResponse);
                } catch (err) {
                    console.log(err);
                }
            };

            if (item.tagName === 'SELECT' || item.tagName === 'INPUT') {
                item.addEventListener('change', handleEvent);
            } else {
                item.addEventListener('click', handleEvent);
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    function createFormData(JSONData) {
        const formData = new FormData();
        for (const [key, value] of Object.entries(JSONData)) {
            if (value.startsWith('#')) {
                const element = document.querySelector(value);
                if (element) {
                    if (element.type === 'checkbox') {
                        formData.append(key, element.checked ? element.value : '');
                    } else {
                        formData.append(key, element.value);
                    }
                } else {
                    formData.append(key, '');
                }
            } else if (value.startsWith('.')) {
                const element = document.querySelector(`[name="${value.substring(1)}"]:checked`);
                formData.append(key, element ? element.value : '');
            } else {
                formData.append(key, value);
            }
        }
        return formData;
    }

    async function sendData(url, data) {
        const options = {
            method: App.apiMethod,
            ...(App.apiMethod === 'POST' && { body: data })
        };
        const response = await fetch(url, options);
        return response.json();
    }

    function processResponse(item) {
        const element = document.getElementById(item.controlid);

        switch (item.type) {
            case 'content':
                if (element) {
                    if (element.tagName === 'SELECT') {
                        let options = '';
                        item.data.forEach(option => {
                            options += `<option value="${option.value}" ${option.selected ? 'selected' : ''}>${option.text}</option>`;
                        });
                        element.innerHTML = options;
                    } else if (element.tagName === 'INPUT') {
                        element.value = item.data;
                    } else {
                        element.innerHTML = item.data;
                    }
                }
                break;
            case 'redirect':
                location.href = item.data;
                break;
            case 'remove':
                if (element) element.remove();
                break;
            case 'refresh':
                location.reload();
                break;
            case 'replace':
                if (element) {
                    const newElem = document.createRange().createContextualFragment(item.data);
                    element.replaceWith(newElem);
                }
                break;
            case 'append':
                if (element) {
                    const newElem = document.createRange().createContextualFragment(item.data);
                    element.appendChild(newElem);
                } else {
                    if (document.querySelector('.g-modal')) {
                        document.querySelector('.g-modal').remove();
                    }
                    const newElem = document.createRange().createContextualFragment(item.data);
                    document.body.appendChild(newElem);

                    if (document.querySelector('.g-modal__window')) {
                        document.body.classList.add('modal-body');
                        document.querySelector('.g-modal').addEventListener('mousedown', handleModalClick);
                        document.addEventListener('keyup', handleModalEscape);
                    }
                }
                break;
            default:
                break;
        }
    }

    function handleModalClick(e) {
        if (e.target.closest('.close-modal, .js-close-modal') || !e.target.closest('.g-modal__window')) {
            if (e.which === 1) {
                closeModal();
            }
        }
    }

    function handleModalEscape(e) {
        if (e.key === 'Escape') {
            closeModal();
        }
    }

    function closeModal() {
        try {
            document.querySelector('.g-modal').remove();
            document.body.classList.remove('modal-body');
        } catch (e) {
            console.log('Exception thrown: ' + e);
        }
    }
};